<template>
    <b-modal :visible="value" title="설정 복사" size="md" hide-footer @input="$emit('input', $event)" @hide="$emit('input', false)">
        <div class="modal-form-compact">
            <div class="form-group-compact" style="grid-column: 1 / -1">
                <label>원본 설정</label>
                <div style="padding: 8px; background: #f8fafc; border-radius: 4px; font-size: 12px">
                    <div><strong>조직:</strong> {{ copyingConfig?.organization?.orgName || "-" }}</div>
                    <div><strong>시설:</strong> {{ copyingConfig?.facility?.facilityName || "전체" }}</div>
                    <div><strong>카테고리:</strong> {{ copyingConfig?.category?.categoryName || "-" }}</div>
                    <div>
                        <strong>기간:</strong> {{ copyingConfig?.startMonth || "-" }} ~
                        {{ copyingConfig?.endMonth || "무기한" }}
                    </div>
                </div>
            </div>
            <div class="form-group-compact">
                <label>대상 조직 <span style="color: red">*</span></label>
                <CarbonSelect
                    :value="localForm.orgIdx == null ? '' : localForm.orgIdx"
                    :options="orgSelectOptions"
                    placeholder="조직 선택"
                    :placeholderDisabled="false"
                    @input="localForm.orgIdx = $event === '' ? null : $event"
                />
            </div>
            <div class="form-group-compact">
                <label>대상 시설</label>
                <CarbonSelect
                    :value="localForm.facilityIdx == null ? '' : localForm.facilityIdx"
                    :options="facilitySelectOptions"
                    placeholder="전체 시설"
                    :placeholderDisabled="false"
                    @input="localForm.facilityIdx = $event === '' ? null : $event"
                />
            </div>
            <div class="form-group-compact">
                <label>새 시작월 <span style="color: red">*</span></label>
                <DatePicker
                    v-model="localForm.startMonth"
                    type="month"
                    format="YYYYMM"
                    placeholder="YYYYMM"
                    value-type="format"
                />
            </div>
            <div class="form-group-compact">
                <label
                    >새 종료월
                    <span style="font-size: 10px; color: #94a3b8; font-weight: normal">(미입력 시 무기한)</span></label
                >
                <div style="display: flex; gap: 4px">
                    <DatePicker
                        v-model="localForm.endMonth"
                        type="month"
                        format="YYYYMM"
                        placeholder="YYYYMM"
                        value-type="format"
                    />
                    <CarbonButton
                        v-if="localForm.endMonth"
                        variant="clear"
                        @click="localForm.endMonth = null"
                        title="종료월 지우기"
                    >
                        지우기
                    </CarbonButton>
                </div>
            </div>
            <div class="form-group-compact" style="grid-column: 1 / -1; margin-top: 8px">
                <div class="copy-modal-hint">
                    <strong>안내:</strong> 복사된 설정은 <strong>초안(draft)</strong> 상태로 생성됩니다. 생성 후
                    수정하여 활성화할 수 있습니다.
                </div>
            </div>
        </div>
        <div class="modal-footer-compact">
            <CarbonButton @click="$emit('input', false)">취소</CarbonButton>
            <CarbonButton
                variant="primary"
                :disabled="!localForm.orgIdx || !localForm.startMonth"
                @click="onSave"
            >
                복사
            </CarbonButton>
        </div>
    </b-modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import CarbonButton from "../../common/CarbonButton.vue";
import CarbonSelect from "../../common/CarbonSelect.vue";

export default {
    name: "ActivityConfigCopyModal",
    components: { DatePicker, CarbonButton, CarbonSelect },
    props: {
        value: { type: Boolean, default: false },
        copyingConfig: { type: Object, default: null },
        copyForm: {
            type: Object,
            default: () => ({ orgIdx: null, facilityIdx: null, startMonth: null, endMonth: null }),
        },
        organizations: { type: Array, default: () => [] },
        facilities: { type: Array, default: () => [] },
    },
    data() {
        return {
            localForm: { orgIdx: null, facilityIdx: null, startMonth: null, endMonth: null },
        };
    },
    computed: {
        orgSelectOptions() {
            return this.organizations.map((o) => ({ value: o.orgIdx, text: o.orgName }));
        },
        facilitySelectOptions() {
            return this.facilities.map((f) => ({
                value: f.facilityIdx || f.orgFacilityIdx,
                text: f.facilityName,
            }));
        },
    },
    watch: {
        value(visible) {
            if (visible) this.localForm = { ...this.copyForm };
        },
        copyForm: {
            handler(v) {
                if (v && this.value) this.localForm = { ...v };
            },
            deep: true,
        },
    },
    methods: {
        onSave() {
            this.$emit("save", { ...this.localForm });
            this.$emit("input", false);
        },
    },
};
</script>

<style scoped>
.modal-form-compact {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.form-group-compact {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.form-group-compact label {
    font-size: 12px;
    font-weight: 500;
    color: #475569;
}

.btn-compact.btn-clear {
    flex-shrink: 0;
}

.copy-modal-hint {
    padding: 8px;
    background: #fffbeb;
    border: 1px solid #fcd34d;
    border-radius: 4px;
    font-size: 11px;
    color: #92400e;
}

.modal-footer-compact {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 0 0;
}
</style>
